import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=ce4b0ef8&scoped=true&"
import script from "./AlertList.vue?vue&type=script&lang=ts&"
export * from "./AlertList.vue?vue&type=script&lang=ts&"
import style0 from "./AlertList.vue?vue&type=style&index=0&id=ce4b0ef8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4b0ef8",
  null
  
)

export default component.exports